// extracted by mini-css-extract-plugin
module.exports = {"follow-bar":"follow-bar--2dDV5","logo":"logo--9VWMW","info":"info--tbxeo","focus-button":"focus-button--lcX1D","close":"close--4yOMQ"};